import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-loading",
  "use": "icon-loading-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"klk-loading-spin-icon\" viewBox=\"0 0 24 24\" id=\"icon-loading\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"12\" cy=\"12\" r=\"10\" opacity=\".291\" /><path stroke=\"currentColor\" stroke-linecap=\"round\" stroke-width=\"3\" d=\"M21.52 15.07c.312-.967.48-1.999.48-3.07 0-4.462-2.923-8.242-6.958-9.529\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol